import React, { useContext, useCallback, useEffect } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import metadata from './SubcontractorsWorkComponent.metadata.json5';

import SubContractorsComponent from '../subcomponents/SubContractors/SubContractorsComponent'
import styles from '../ArchitectEngineer.module.scss';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function SubcontractorsWorkComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('SubcontractorsWorkComponent');
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        pleExp4: {
            visible: !_.isUndefined(modelVM.doeTheAppReqEviOfPro3.value) && !modelVM.doeTheAppReqEviOfPro3.value
        },
        namOfJoiVen6: {
            visible: !_.isUndefined(modelVM.isTheAppComInvInAny5.value) && modelVM.isTheAppComInvInAny5.value
        },
        pleExp7: {
            visible: !_.isUndefined(modelVM.isTheAppComInvInAny5.value) && modelVM.isTheAppComInvInAny5.value
        },
        subContractorsComponent: {
            data: modelVM.subContractorsDTO,
            updateWizardData,
            submissionVM,
            SubcontractorsPath: `${pathUpdated}.subContractorsDTO`
        }
    };

    useEffect(() => {
        updateWizardData(submissionVM);
    }, [])


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            subContractorsComponent: SubContractorsComponent
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

SubcontractorsWorkComponent.propTypes = wizardProps;
export default withRouter(SubcontractorsWorkComponent);
